

























import Vue from 'vue';
import FileUpload from 'vue-upload-component';
import XLSX from 'xlsx';

export default Vue.extend({
  components: {
    FileUpload,
  },
  props: {
    confirmText: {
      type: String,
      default: '确定导入',
    },
    uploadUrl: {
      type: String,
      default: 'api-crm-web/customer/uploadRemarkExcel',
    },
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    inputFilter(newFile: any, oldFile: any, prevent: any) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile: any, oldFile: any) {
      (this.$refs.upload as any).active = true;
      if (newFile && oldFile && newFile.active !== oldFile.active) {
        this.$Message.info({
          content: '正在上传文件...',
          duration: 1000000,
        });
      }
      if (newFile && newFile.response && newFile.response.result) {
        (this.$refs.upload as any).active = false;
        this.$Message.destroy();
        this.$emit('success', newFile.response.result);
      }
    },
    // 前端读取excel数据，暂时还没有用
    // readerData(itemFile: any) {
    //   if (itemFile.name.split('.')[1] !== 'xls' && itemFile.name.split('.')[1] !== 'xlsx') {
    //     // this.$message({message: '上传文件格式错误，请上传xls、xlsx文件！',type: 'warning'});
    //   } else {
    //     const reader = new FileReader();
    //     reader.onload = (e: any) => {
    //       const data = e.target.result;
    //       const fixedData = this.fixdata(data);
    //       const workbook = XLSX.read(btoa(fixedData), { type: 'base64' });
    //       const firstSheetName = workbook.SheetNames[0]; // 第一张表 sheet1
    //       const worksheet = workbook.Sheets[firstSheetName]; // 读取sheet1表中的数据
    //       const tableTitle = firstSheetName;
    //       const header = this.get_header_row(worksheet);
    //       const results = XLSX.utils.sheet_to_json(worksheet);
    //       // this.generateDate({ tableTitle, header, results })
    //     };
    //     reader.readAsArrayBuffer(itemFile.file);
    //   }
    // },
    // fixdata(data: any) {
    //   let o = '';
    //   let l = 0;
    //   const w = 10240;
    //   for (; l < data.byteLength / w; ++l);
    //   o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
    //   o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
    //   return o;
    // },
    // get_header_row(sheet: any) {
    //   const headers = [];
    //   const range = XLSX.utils.decode_range(sheet['!ref'])
    //   let C, R = range.s.r; /* start in the first row */
    //   for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
    //     let cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]; /* find the cell in the first row */
    //     let hdr = 'UNKNOWN ' + C; // <-- replace with your desired defaultif (cell && cell.t) 
    //     hdr = XLSX.utils.format_cell(cell);
    //     headers.push(hdr);
    //   }
    //   return headers;
    // }
  },
});
